import * as React from 'react';
import { __ } from '../../helpers/TranslationService';
import { IPromotionBanner } from '../../interfaces/IBanner';
import styled from '@emotion/styled';

const PromoBarStyled = styled.div<{ backgroundColor?: string }>`
    color: ${({ theme }) => theme.text.color.primaryInverse};
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    text-align: center;
    padding: 12px 16px;
    background-color: ${({ backgroundColor, theme }) =>
        backgroundColor || theme.colors.turtleGreen[100]};
`;

const PromoBarLink = styled.a`
    color: ${({ theme }) => theme.text.color.primaryInverse};
    text-decoration: underline;
    &:hover {
        color: ${({ theme }) => theme.text.color.primaryInverse};
    }
`;

export const PromoBar = React.forwardRef(
    (props: IPromotionBanner, inputRef: React.LegacyRef<HTMLDivElement>) => {
        const { headline, linkDescription, linkUrl, backgroundColor } = props;

        return (
            headline && (
                <PromoBarStyled ref={inputRef} backgroundColor={backgroundColor}>
                    {headline}{' '}
                    {linkUrl && linkDescription && (
                        <PromoBarLink href={linkUrl}>{linkDescription}</PromoBarLink>
                    )}
                </PromoBarStyled>
            )
        );
    },
);
